import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTheme } from '../../contexts/ThemeContext';
import { Button } from '../../components/ui/Button';
import { Card } from '../../components/ui/Card';
import { Home, ArrowLeft, Search } from 'lucide-react';

// Import the logos
import CrutanLogoNavy from '../../logos/All Navy Crutan Logo.svg';
import CrutanLogoWhite from '../../logos/All White Crutan Logo.svg';

export function NotFoundPage() {
  const navigate = useNavigate();
  const { theme } = useTheme();

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-200 via-gray-100 to-slate-200 dark:from-gray-900 dark:via-slate-700 dark:to-gray-900 flex items-center justify-center p-4">
      <Card className="p-8 max-w-md w-full text-center">
        {/* 404 Illustration */}
        <div className="mb-6">
          <div className="text-6xl font-bold text-gray-300 dark:text-gray-600 mb-2">404</div>
          <div className="mb-4">
            <img 
              src={theme === 'dark' ? CrutanLogoWhite : CrutanLogoNavy}
              alt="Crutan Logo"
              className="h-12 mx-auto"
            />
          </div>
        </div>

        {/* Content */}
        <h1 className="text-2xl font-bold text-gray-900 dark:text-white mb-2">Page not found</h1>
        <p className="text-gray-600 dark:text-gray-300 mb-6">
          Sorry, we couldn't find the page you're looking for. It might have been moved, deleted, or you entered the wrong URL.
        </p>

        {/* Actions */}
        <div className="space-y-3">
          <Button 
            onClick={() => navigate('/dashboard')}
            className="w-full bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-700 hover:to-purple-700"
          >
            <Home className="w-4 h-4 mr-2" />
            Go to Dashboard
          </Button>
          <Button 
            variant="outline" 
            onClick={() => navigate(-1)}
            className="w-full"
          >
            <ArrowLeft className="w-4 h-4 mr-2" />
            Go Back
          </Button>
        </div>

        {/* Help Links */}
        <div className="mt-6 pt-6 border-t border-gray-200 dark:border-gray-700">
          <p className="text-sm text-gray-500 dark:text-gray-400 mb-3">Need help?</p>
          <div className="flex justify-center space-x-4 text-sm">
            <a href="/help" className="text-blue-600 dark:text-blue-400 hover:text-blue-700 dark:hover:text-blue-300">
              Help Center
            </a>
            <a href="/contact" className="text-blue-600 dark:text-blue-400 hover:text-blue-700 dark:hover:text-blue-300">
              Contact Support
            </a>
          </div>
        </div>
      </Card>
    </div>
  );
}